import button from './button'
import card from './card'
import divider from './divider'
import footer from './footer'
import form from './form'
import formURL from './formURL'
import header from './header'
import icon from './icon'
import input from './input'
import media from './media'
import text from './text'
import webinar from './webinar'
import illustration from './illustration'
import question from './question'
import questionMultipleChoice from './questionMultipleChoice'
import questionMediaAnswer from './questionMediaAnswer'
import questionTextAnswer from './questionTextAnswer'
import list from './list'
import listItem from './listItem'

export default {
  button,
  card,
  divider,
  footer,
  form,
  formURL,
  header,
  icon,
  input,
  questionMediaAnswer,
  questionTextAnswer,
  media,
  text,
  webinar,
  illustration,
  list,
  listItem,
  questionMultipleChoice,
  questionText: question,
  questionMedia: question,
  questionForm: question,
}
